import { render, staticRenderFns } from "./shareSheetComponent.vue?vue&type=template&id=48691fb7&scoped=true"
import script from "./shareSheetComponent.vue?vue&type=script&lang=js"
export * from "./shareSheetComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48691fb7",
  null
  
)

export default component.exports